import { render } from "./DettaglioRaccolta.vue?vue&type=template&id=7d517d9e&scoped=true"
import script from "./DettaglioRaccolta.vue?vue&type=script&lang=js"
export * from "./DettaglioRaccolta.vue?vue&type=script&lang=js"

import "./DettaglioRaccolta.vue?vue&type=style&index=0&id=7d517d9e&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d517d9e"]])

export default __exports__